import { Pipe, PipeTransform } from '@angular/core';
import { StrippedMacFilter } from '../../src/filters/FormatStrippedMac';

@Pipe({
    name: 'strippedMac'
})
export class StrippedMacPipe implements PipeTransform {
    public transform(value: string): string {
        // at this point, we still need the Angular1.x implementation, so just import it here and use it directly.
        // once we convert everything, we can move that implementation here. TODO

        let func = StrippedMacFilter.Factory();

        return func(value);
    }
}
